<div class="page__inner">
    @if (isLoading()) {
        <p class="page__status">{{ 'cms.dynamicPage.loading' | translate }}</p>
    } @else if (notFound()) {
        <app-not-found />
    } @else if (cmsGroups().length) {
        <cms-sections [groups]="cmsGroups()" />
    }
</div>
